module.exports = __webpack_public_path__ + "img/Flags_of_New_Caledonia.0a295d09.svg";